import React from "react"
import {connect} from "react-redux";
import {Button, Col, Row} from "antd"
import PropTypes from "prop-types"
import PersonTable from "./PersonTable"
import * as PersonActions from "../../reducers/person"
import {bindActionCreators} from "redux"
import {NavLink} from "react-router-dom"
import PersonAffiliations from "./PersonAffiliations";
import BrowseView from "../BrowseView";

class PersonView extends React.Component {

    static propTypes = {
        persons: PropTypes.array.isRequired,
        links: PropTypes.array.isRequired,
        getPersons: PropTypes.func.isRequired,
        getLinks: PropTypes.func.isRequired,
        fetchingPersons: PropTypes.bool.isRequired,
        fetchingLinks: PropTypes.bool.isRequired,
        search: PropTypes.func.isRequired
    };
    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };


    state = {
        selectedRowKeys: [],
        visible: false,
        confirmLoading: false
    };

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
        this.props.getLinks(selectedRowKeys);
    };

    render() {
        const {getPersons, persons, links, fetchingPersons, fetchingLinks, search} = this.props;
        const {selectedRowKeys} = this.state;
        const selectedId = selectedRowKeys[0];
        const disabled = selectedRowKeys.length === 0;
        const titleBar = <Row>
            <Col span={4}>Person  Index</Col>
            <Col span={1} offset={19}>
                <NavLink to={`/person/${selectedId}`}>
                    <Button type='primary' disabled={disabled}>Open</Button>
                </NavLink>
            </Col>
        </Row>;

        return <BrowseView
            masterTitle={titleBar}
            master={<PersonTable dataSource={persons} onSelectChange={this.onSelectChange} loading={fetchingPersons} compact={false}/>}
            detailTitle={'Affiliations'}
            detail={<PersonAffiliations links={links} loading={fetchingLinks}/>}
            initialQuery={getPersons}
            searchableProps={["id","firstName","lastName","persType","specialties","ct","ut","apurebaseId","title","persType","country","customerId"]}
            searchLogic={search}
            loading={fetchingPersons}
        />
    }
}

const mapStateToProps = state => ({
    persons: state.person.persons,
    links: state.person.links,
    fetchingPersons: state.person.fetchingPersons,
    fetchingLinks: state.person.fetchingLinks
});

const mapDispatchToProps = dispatch => ({
    getPersons: bindActionCreators(PersonActions, dispatch).getPersons,
    getLinks: bindActionCreators(PersonActions, dispatch).getLinks,
    search: bindActionCreators(PersonActions, dispatch).search
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonView)



// WEBPACK FOOTER //
// ./src/js/browse/person/PersonView.js